
export default function AttrsTranslateService() {

    return {
        translateKey: function (key, language) {

            if (!language) {
                language = 'EN';
            }

            return "";
        }
    };
}
